<script>
export default {
    name: 'BaseContent',
    props: {
        title: {
            type: String,
            default: '',
        },
    },
}
</script>

<template>
    <div :class="$style.container">
        <div
            v-if="title"
            :class="$style.mainHeading"
        >{{ title }}</div>
        <slot />
    </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
    position: relative;
    z-index: $layer-page-z-index;
}

.mainHeading {
    @include h3;

    margin-top: $s-s;
    margin-bottom: $s-xxl;
    letter-spacing: 0.25px;

    @include desktop {
        @include container;
        @include h1;

        margin-bottom: $s-xxl;
    }

    @include sidePadding;
}
</style>
